/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BankCardVo } from './BankCardVo';
import {
    BankCardVoFromJSON,
    BankCardVoFromJSONTyped,
    BankCardVoToJSON,
    BankCardVoToJSONTyped,
} from './BankCardVo';

/**
 * 
 * @export
 * @interface PageDataBankCardVo
 */
export interface PageDataBankCardVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataBankCardVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataBankCardVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataBankCardVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<BankCardVo>}
     * @memberof PageDataBankCardVo
     */
    records?: Array<BankCardVo>;
}

/**
 * Check if a given object implements the PageDataBankCardVo interface.
 */
export function instanceOfPageDataBankCardVo(value: object): value is PageDataBankCardVo {
    return true;
}

export function PageDataBankCardVoFromJSON(json: any): PageDataBankCardVo {
    return PageDataBankCardVoFromJSONTyped(json, false);
}

export function PageDataBankCardVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataBankCardVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(BankCardVoFromJSON)),
    };
}

export function PageDataBankCardVoToJSON(json: any): PageDataBankCardVo {
    return PageDataBankCardVoToJSONTyped(json, false);
}

export function PageDataBankCardVoToJSONTyped(value?: PageDataBankCardVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(BankCardVoToJSON)),
    };
}

